import { AvailabilityConstraintHistory } from 'types'
import { CustomAvatar } from './CustomAvatar'

type Props = {
  system: Required<AvailabilityConstraintHistory['created_by']>['system']
}

const System = ({ system }: Props) => <CustomAvatar title={system}>{system.charAt(0)}</CustomAvatar>

export { System }
